import Joi from 'joi';
import { getJoiObject } from '../../utils/JoiUtils';

export interface CreateEditTemplateData {
  announcementTitle: string;
}

const createEditTemplateSchema = (isSms: boolean) =>
  Joi.object({
    announcementTitle: getJoiObject(
      isSms
        ? Joi.string()
            .trim()
            .min(1)
            .required()
            .regex(/[|^€{}[~\]\\`]/, { invert: true })
            .messages({
              'any.required': 'Title is not allowed to be empty.',
              'string.empty': 'Title is not allowed to be empty.',
              'string.pattern.invert.base':
                'The following special characters |^€}{~[]\\` are not allowed.',
            })
        : Joi.string().trim().min(1).required().messages({
            'any.required': 'Title is not allowed to be empty.',
            'string.empty': 'Title is not allowed to be empty.',
          })
    ),
  });

export default createEditTemplateSchema;
